import { useMutation } from "@apollo/client";
import { SEND_PROCESS_MESSAGE } from "src/operations/mutations/sendProcessMessage";
import {
    SendProcessMessage,
    SendProcessMessageVariables
} from "src/operations/mutations/__generated__/SendProcessMessage";

export function useSendProcessMessage() {
    const processMassageMutation = useMutation<SendProcessMessage, SendProcessMessageVariables>(SEND_PROCESS_MESSAGE);
    return { processMassageMutation };
}
